function Footer() {
  return (
    <footer className="fixed bottom-0 right-0 left-0 bg-slate-800 text-white">
      <div className="container mx-auto max-w-5xl py-2">
        <p className="text-center font-bold">All rights reserved © <span><a href="https://pabitrabanerjee.newsgoogle.org">Pabitra Banerjee</a></span></p>
      </div>
    </footer>
  );
}

export default Footer;
